import React from "react";
import moment from "moment";
import { BsClockFill, BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FaRegCalendarDays } from "react-icons/fa6";

const TodayAppointments = ({ orders = [] }) => {
  const now = moment();
  const today = moment().format("YYYY-MM-DD");

  console.log({ orders });

  // 🔥 filter today orders (9AM–6PM)
  const ordersToday = orders
    .filter((order) => {
      if (!order?.createdAt) return false;

      const m = moment(order.createdAt);
      const date = m.format("YYYY-MM-DD");
      const hour = m.hour();

      return date === today && hour >= 9 && hour < 18;
    })
    .sort((a, b) => moment(a.createdAt) - moment(b.createdAt));

  // 🔥 stats
  const total = ordersToday.length;

  const totalConfirmed = ordersToday.filter(
    (o) => o.orderStatus !== "cancelled",
  ).length;

  const totalCancelled = ordersToday.filter(
    (o) => o.orderStatus === "cancelled",
  ).length;

  // 🔥 format UI data
  const formatted = ordersToday.map((order) => {
    const start = moment(order.createdAt);
    const end = start.clone().add(30, "minutes");

    const status = now.isAfter(end) ? "Completed" : "Upcoming";

    return {
      id: order._id,
      time: start.format("hh:mm A"),
      from: start.format("hh:mm A"),
      to: end.format("hh:mm A"),
      status,
      user: {
        title:
          order.user?.displayName ||
          order.customer_info?.firstname ||
          "Customer",
        photo: order.user?.photo || "/images/diamond_logo2.png",
      },
    };
  });

  return (
    <div className="bg-dry rounded-xl border border-border p-5 min-h-[500px]">
      {/* 🔥 NEW HEADER */}
      <div className="flex justify-between items-start mb-6">
        <div>
          <p className="text-xs uppercase tracking-widest text-navy">
            Today's Orders
          </p>

          <div className="flex items-end gap-3 mt-2">
            <h2 className="text-4xl font-bold text-navy">{total}</h2>
            <span className="text-sm text-gray-500 pb-1">today</span>
          </div>

          <p className="text-sm text-gray-400 mt-1">
            {totalConfirmed} confirmed • {totalCancelled} cancelled
          </p>
        </div>

        <div className="px-3 py-1 text-xs rounded-full bg-green-50 text-green-600 font-medium">
          Live
        </div>
      </div>

      {/* 🔥 EMPTY STATE */}
      {formatted.length === 0 && (
        <p className="text-textGray text-sm">No orders today.</p>
      )}

      {/* 🔥 LIST */}
      {formatted.map((item) => (
        <div
          key={item.id}
          className="grid grid-cols-12 gap-2 items-center mb-4"
        >
          {/* TIME + STATUS */}
          <div className="col-span-3 text-[12px] flex items-center gap-2 flex-wrap">
            <span className="text-textGray">{item.time}</span>

            <span
              className={`px-2 py-[2px] rounded-full text-[10px] uppercase flex items-center gap-1
              ${
                item.status === "Upcoming"
                  ? "bg-yellowstar text-navy"
                  : "bg-green-500 text-white"
              }`}
            >
              {item.status === "Upcoming" && <FaRegCalendarDays />}
              {item.status === "Completed" && <BsCheckCircleFill />}
              {item.status}
            </span>
          </div>

          {/* TIMELINE */}
          <div className="flex-colo relative col-span-2">
            <hr className="w-[2px] h-20 bg-border" />

            <div
              className={`w-7 h-7 flex items-center justify-center text-sm rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
              ${
                item.status === "Upcoming"
                  ? "bg-yellowstar text-navy"
                  : "bg-green-100 text-green-500"
              }`}
            >
              {item.status === "Upcoming" && <FaRegCalendarDays />}
              {item.status === "Completed" && <BsClockFill />}
            </div>
          </div>

          {/* USER */}
          <Link
            to={`/order/preview/${item.id}`}
            className="flex gap-2 col-span-6"
          >
            <img
              src={item.user.photo}
              alt={item.user.title}
              className="w-8 h-8 rounded-full object-cover"
            />

            <div className="flex flex-col gap-1">
              <h2 className="text-xs text-text">{item.user.title}</h2>

              <p className="text-[12px] text-yellowlight">
                {item.from} - {item.to}
              </p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default TodayAppointments;
